import React from "react";
import { Container, Row, Button } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Mousewheel } from "swiper";
import { StarFill } from "react-bootstrap-icons";
import {
  bestProducts, bestProduct,
  bpTitle, clipStar, ratingDesc, publisher,
  productsDesc, products, allProducts, yStars
} from "./style.mod.scss";
import locale from "locales";
import Image from "components/image";

const BestProducts = ({ data }) => {
  const { slider, title, bgColor, scrollProduct } = data;

  const settings = {
    loop: true,
    navigation: { clickable: true },
    pagination: { clickable: true },
    modules: [Pagination, Navigation, Mousewheel],
    slidesPerView: 1,
    speed: 800,
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    slidesPerGroup: 1,
    responsive: [
      { breakpoint: 767 },
    ]
  };

  return (
    <div className={bestProducts}
      style={{ backgroundColor: bgColor && bgColor.hex }}>
      <Container>
        <div className={bestProduct}>
          <h2 className={bpTitle}>{title}</h2>

          <a className={yStars}>
            <div className={clipStar}>
              <StarFill />
              <StarFill />
              <StarFill />
              <StarFill />
              <StarFill />
            </div>
          </a>
          <h5 className={ratingDesc}>{locale.pages.reviewCount}</h5>

          <Swiper {...settings}>
            {slider.map((s) => {

              return (
                <SwiperSlide key={s._key}>
                  <h3 className={productsDesc}> {s.reviewContent}</h3>
                  <h5 className={publisher}>{s.reviewerName}</h5>
                  <Row>
                    <div className={products}>
                      {s.slideImage?.map((si, i) => <Image key={i} image={si} alt={si?.alt} />)}
                    </div>
                  </Row>
                </SwiperSlide>
              );
            }
            )}
          </Swiper>
          <Button href={scrollProduct ? `/${locale.pages.reviews.reviewsUrl}` : "#y-product-reviews"} className={allProducts}>{locale.pages.reviews.allReviews}</Button>
        </div>
      </Container>
    </div>
  );
};

export default BestProducts;
